<template>
  <div class="left-top-list">
    <titleComponent titleName="资源分布">
    </titleComponent>
    <div class="flex" style="margin-top: 8px;">
        <leftTopLeft></leftTopLeft>
        <leftTopRight></leftTopRight>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleComponent from "@/pages/patrolScreenMini/components/title.vue";
import leftTopLeft from "@/pages/patrolScreenMini/components/left/left-top-left.vue";
import leftTopRight from "@/pages/patrolScreenMini/components/left/left-top-right.vue";
export default {
  name: "index",
  components: {
    wgEchart,
    titleComponent,
    leftTopLeft,
    leftTopRight
  },
  data() {
    return {
      optionsOne: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.left-top-list {
  width: 100%;
  height: 530px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/left/left-top.vue